import type { PropsWithChildren, JSX } from 'react';

import { Button, Card, Col, Dropdown, Row } from 'antd';
import { useMediaQuery } from 'react-responsive';

import { ScreenBreakpoint } from '../../../styles';

import * as Styles from './DropdownFilterButton.styles';

interface DropdownFilterButtonProps {
  label?: string | JSX.Element;
  isDirty?: boolean;
  testId?: string;
}

export const DropdownFilterButton = ({
  children,
  label,
  isDirty = false,
  testId,
}: PropsWithChildren<DropdownFilterButtonProps>) => {
  const isMobile = useMediaQuery({ query: `(max-width: ${ScreenBreakpoint.mobile.max})` });

  const renderFilters = (): JSX.Element => {
    return (
      <Card className={Styles.cardContent}>
        <>
          <Row gutter={[, 16]}>
            <Col span={24}>{children}</Col>
          </Row>
        </>
      </Card>
    );
  };

  const renderInMobile = (): JSX.Element => (
    <Row>
      <Col span={24}>
        <div>{children}</div>
      </Col>
    </Row>
  );

  const render = (): JSX.Element => (
    <Dropdown dropdownRender={() => renderFilters()} destroyPopupOnHide trigger={['click']} placement='bottomLeft'>
      <Button type='link' className={Styles.button({ isDirty })} data-testid={testId}>
        {label}
      </Button>
    </Dropdown>
  );

  return <>{isMobile ? renderInMobile() : render()}</>;
};
